import { render, staticRenderFns } from "./CreateWalletLayout.vue?vue&type=template&id=678474be&scoped=true&"
import script from "./CreateWalletLayout.vue?vue&type=script&lang=js&"
export * from "./CreateWalletLayout.vue?vue&type=script&lang=js&"
import style0 from "./CreateWalletLayout.vue?vue&type=style&index=0&id=678474be&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "678474be",
  null
  
)

export default component.exports